import { render } from "./HeaderHomeComponent.vue?vue&type=template&id=aa4d1980&scoped=true"
import script from "./HeaderHomeComponent.vue?vue&type=script&lang=js"
export * from "./HeaderHomeComponent.vue?vue&type=script&lang=js"

import "./HeaderHomeComponent.vue?vue&type=style&index=0&id=aa4d1980&scoped=true&lang=css"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4d1980"]])

export default __exports__